import { TextField } from "@mui/material";
import React, { useState } from "react";
import { AiOutlineSearch } from "react-icons/ai";
export default function TableSearch(props) {
  const [text, setText] = useState();

  const Styles = {};

  return (
    <TextField
      className={props.className}
      disabled={props.search ? false : true}
      fullWidth
      label={props.label ? props.label : "جستجو"}
      size="small"
      onChange={({ target: { value } }) => {
        if (value.length % 3 == 0) {
          props.search && props.search(value);
        }
        setText(value);
      }}
      onKeyDown={e => {
        if (e.key == "Enter") {
          props.search && props.search(text);
        }
      }}
    />
  );
}
